import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-client-batch-id',
  templateUrl: './client-batch-id.component.html',
  styleUrl: './client-batch-id.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClientBatchIdComponent {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  clientBatchId$ = this.taskWorkspaceStore('task')('client_batch_identifier').$;
}
